import formModel from './formModel';

const {
  formField: {
    dokumen,
    pegawai,
    nama,
    keterangan,
    penerima,
    penyerah,
    tglTerima,
    tglSerah
  }
} = formModel;

export default {
  [dokumen.name]: '',
  [pegawai.name]: '',
  [nama.name]: '',
  [keterangan.name]: '',
  [penerima.name]: '',
  [penyerah.name]: '',
  [tglTerima.name]: '',
  [tglSerah.name]: ''
};
